import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../../components/components.module';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {httpLoaderFactory} from '../../app.module';
import {CdkDrag, CdkDragHandle, DragDropModule} from '@angular/cdk/drag-drop';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {AppMaterialModule} from '../../app.material.module';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';

import {
    LucideAngularModule, Lock, Mail, UserRound, MonitorCog,
    Monitor,
    Eye

} from 'lucide-angular';
import {MatBadgeModule} from '@angular/material/badge';
import {AppGgLoginPageComponent} from './components/gg-login-page/gg-login-page.component'
import {AppGgLoginFormComponent} from './components/gg-login-form/gg-login-form.component'
import {AppGgActivateFormComponent} from './components/gg-activate-form/gg-activate-form.component'
import {AppGgProjectsListComponent} from './components/gg-projects-list/gg-projects-list.component'
import {MatListModule} from '@angular/material/list';

@NgModule({
    declarations: [
        AppGgLoginPageComponent,
        AppGgLoginFormComponent,
        AppGgProjectsListComponent,
        AppGgActivateFormComponent,
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        CdkDrag,
        CdkDragHandle,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        MatButtonModule,
        MatDialogModule,
        MatSlideToggle,
        AppMaterialModule,
        MatTooltipModule,
        MatIconModule,
        MatFormFieldModule,
        MatBadgeModule,
        MatListModule,
        LucideAngularModule.pick({
            Lock,
            Mail,
            UserRound,
            MonitorCog,
            Monitor,
            Eye
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'ru',
        })
    ],

    exports: [
        AppGgLoginPageComponent,
        AppGgProjectsListComponent
    ],
    providers: []
})
export class AppGGModule {
}
